<script lang="ts" setup>
import { useI18n } from "vue-i18n";

import SearchField from "@/components/inputs/SearchField.vue";
import TableFilter from "@/components/tables/TableFilter.vue";
import InvoiceStatusSelect from "@/components/selects/InvoiceStatusSelect.vue";
import BillingMethodSelect from "@/components/selects/BillingMethodSelect.vue";
import CustomerSelect from "@/views/orders/components/CustomerSelect.vue";

import type { InvoicesFilter } from "@/types/billing";

const { t } = useI18n();

const filter = defineModel<InvoicesFilter>({ required: true });

const emits = defineEmits<{
  (e: "search"): void;
  (e: "clear"): void;
}>();
</script>

<template>
  <table-filter :expandable="false" :filters="filter" @apply="emits('search')" @clear="emits('clear')">
    <template #header>
      <div class="d-flex align-center">
        <v-icon class="mr-4" icon="mdi-filter-variant" />
        <v-row>
          <v-col cols="2">
            <invoice-status-select v-model="filter.status" clearable @update:model-value="emits('search')" />
          </v-col>
          <v-col cols="2">
            <search-field v-model="filter.number" :label="t('billing.invoice-number')" @search="emits('search')" />
          </v-col>
          <v-col cols="2">
            <search-field v-model="filter.orderId" :label="t('billing.order-number')" @search="emits('search')" />
          </v-col>
          <v-col cols="2">
            <search-field v-model="filter.refNumber" :label="t('billing.ref-number')" @search="emits('search')" />
          </v-col>
          <v-col cols="2">
            <customer-select
              v-model="filter.customerId"
              :label="t('billing.bill-to-company')"
              hide-details
              @update:model-value="emits('search')"
            />
          </v-col>
          <v-col cols="2">
            <billing-method-select v-model="filter.paymentType" clearable @update:model-value="emits('search')" />
          </v-col>
        </v-row>
      </div>
    </template>
  </table-filter>
</template>
